import React, { useState }  from 'react'
import { BsPlusCircle } from "react-icons/bs";
import { IconContext } from "react-icons";

const TrainingDay = ({ course, onOpenModal}) => {

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const year = date.getFullYear();
        const month = ('0' + (date.getMonth() + 1)).slice(-2); // Ensure 2 digits for month
        const day = ('0' + date.getDate()).slice(-2); // Ensure 2 digits for day
        return `${day}/${month}/${year}`;
    };
    return (
        <div className='text-right  flex flex-col border rounded-md m-2 p-1 ' style={{ direction: "rtl" }}>
            <div className='text-base font-bold underline mb-1'>פרטי יום הכשירות
            </div>
            {/* <div className='text-sm font-bold mb-1'>ציוד מגן אישי - יהודה נייקרוג - באר שבע - צהריים - 1041657 - 1041657 */}
            <div className='text-sm font-bold mb-1'>{course?.mySelfQualificationDto?.name}
            </div>
            <div className='text-xs font-normal mb-1'>{course?.mySelfQualificationDto?.description}
            </div>
            <div className='grid text-xs grid-cols-3'>
                <div className='grid'>
                    <div className='flex items-center'>
                        <div className='ml-2 text-sm  font-bold underline'>תאריך התחלה:</div>
                        <div>{course?.mySelfQualificationDto?.startDate?formatDate(course?.mySelfQualificationDto?.startDate):""}</div>
                    </div>
                    <div className='flex items-center'>
                        <div className='ml-2 text-sm  font-bold underline'>מספר מקומות שנותרו:</div>
                        <div>{course?.participantsAvailable}</div>
                    </div>
                    <div className='flex items-center'>
                        <div className='ml-2  text-sm font-bold underline'>אשכול:</div>
                        <div>{course?.mySelfQualificationDto?.cluster?.name}</div>
                    </div>

                </div>
                <div className='grid '>
                    <div className='flex items-center'>
                        <div className='ml-2 text-sm font-bold underline'>תאריך סיום:</div>
                        <div>{course?.dateEnd?formatDate(course?.dateEnd):""}</div>
                    </div>
                    <div className='flex items-center'>
                        <div className='ml-2 text-sm font-bold underline'>מיקום:</div>
                        <div>{course?.mySelfQualificationDto?.place}</div>
                    </div>
                    <div className='flex items-center'>
                        <div className='ml-2 text-sm font-bold underline'>קוד נושא:</div>
                        <div>{course?.product?.code}</div>
                        
                    </div>
                </div>
                <div className='grid'>
                <div className='flex items-center'>
                        <div className='ml-2 text-sm font-bold underline'>סה"כ ימי כשירות:</div>
                        <div>{course?.daysWork}</div>
                    </div>
                    <div className='flex items-center'>
                        <div className='ml-2 text-sm font-bold underline'>עלות:</div>
                        <div>{course?.product?.price}</div>
                    </div>
                    <div className='flex items-center'>
                        <div className='ml-2 text-sm font-bold underline'>פרטי מדריך:</div>
                        <div>{course?.mySelfQualificationDto?.instructor?.frame_manager}</div>
                    </div>
                </div>

            </div>
            <IconContext.Provider value={{ size:"29px", className:"ml-2" }}>
            <button className='bg-[#1e8e2b] rounded-md text-white p-2 w-fit flex self-end items-center text-sm font-medium' onClick={onOpenModal}> <BsPlusCircle/> להרשמה ופרטים נוספים</button>
            </IconContext.Provider>

        </div>

    )
}

export default TrainingDay




// <div className="max-w-md mx-auto bg-white rounded-2xl shadow-lg overflow-hidden">
//   <div className="relative">
//     <img
//       src={`https://your-base-url.com/${course.mySelfQualificationDto.linkImage}`}
//       alt="תמונת קורס"
//       className="w-full h-48 object-cover"
//     />
//     <div className="absolute bottom-0 left-0 w-full bg-black bg-opacity-40 text-white p-2">
//       <h2 className="text-xl font-bold">{course.mySelfQualificationDto.name}</h2>
//     </div>
//   </div>

//   <div className="p-4 space-y-2 text-right">
//     <p><strong>מיקום:</strong> {course.mySelfQualificationDto.place}</p>
//     <p><strong>מרצה:</strong> {course.mySelfQualificationDto.instructor?.frame_manager || "—"}</p>
//     {/* <p><strong>תאריכים:</strong> {formatDateRange(course.mySelfQualificationDto.activityDays)}</p> */}
//     <p><strong>מספר ימים:</strong> {course.daysWork}</p>
//     <p className="text-gray-600 line-clamp-3">{course.mySelfQualificationDto.description}</p>
//     <p><strong>מחיר:</strong> {course.product.price === 0 ? "חינם" : `${course.product.price} ₪`}</p>
//     <p><strong>נותרו מקומות:</strong> {course.participantsAvailable}</p>

//     <button
//       disabled={course.isRegistered}
//       className={`w-full mt-2 py-2 rounded-xl text-white ${
//         course.isRegistered ? "bg-gray-400 cursor-not-allowed" : "bg-green-600 hover:bg-green-700"
//       }`}
//     >
//       {course.isRegistered ? "כבר נרשמת" : "להרשמה לקורס"}
//     </button>
//   </div>
// </div>